module.exports = __webpack_public_path__ + "public/images/netw-start-conversation-tablet.6708b41243093c1d3ee5d0e60c1bf6e8.jpg";